import { useQuery } from 'react-query';

import { axios } from 'lib';

const getLotRates = (resource, id, lotId) => {
  return axios.get(`/api/${resource}/${id}/rates/lots/${lotId}`);
};

export const useLotRates = (resource, id, lotId, options = {}) => {
  return useQuery(`${resource}-${id}-rates-lots-${lotId}`, () => getLotRates(resource, id, lotId), {
    //@ts-ignore
    initialData: {
      data: {
        data: {
          rates_per_supplier: false,
          level_structures: [],
          roles: [],
          exclusions: [],
          rates: [],
          ranges: [],
          suppliers: [],
        },
      },
    },
    select: ({ data }) => data.data,
    ...options,
  });
};
